/**
 * Master toggle for "Add to Cart" vs "Inquire" UX.
 *
 * When false (default while the gallery is not yet accepting Shopify
 * payments), every Add-to-Cart button renders as an "Inquire" button
 * that opens a contact form; the cart drawer, cart icon, and checkout
 * flow are all hidden. When true, the original Shopify cart UX is
 * restored. The Shopify integration, `pieces.shopify_variant_id`
 * syncing, and checkout redirect logic all remain intact regardless.
 *
 * Flip this by setting `REACT_APP_PURCHASING_ENABLED=true` in
 * /app/frontend/.env (and redeploying) — no code changes needed.
 */
export const PURCHASING_ENABLED =
  String(process.env.REACT_APP_PURCHASING_ENABLED || "").toLowerCase() === "true";
